export default "__VITE_ASSET__DMhjMXZW__"